<template>
    <div class="footer-inner clearfix">
        <div class="footer-list">
            <router-link 
                class="footer-list-item" 
                to="example"
            >
                案例
            </router-link>
            <router-link 
                class="footer-list-item" 
                to="/product"
            >
                产品
            </router-link>
            <router-link 
                class="footer-list-item" 
                to="/method"
            >
                方法
            </router-link>
            <router-link 
                class="footer-list-item" 
                to="/industry-experience"
            >
                行业经验
            </router-link>

            <!-- <a class="footer-list-item" href="javascript:void(0)">方法</a> -->
        </div>
        <div class="footer-list">
            <router-link 
                class="footer-list-item" 
                to="/aboutus"
            >
                关于我们
            </router-link>
            <router-link 
                class="footer-list-item" 
                to="/service"
            >
                我们的服务
            </router-link>
            <router-link 
                class="footer-list-item" 
                to="/contact-us"
            >
                联系我们
            </router-link>
            <!-- <a class="footer-list-item" href="javascript:void(0)">工作机会</a> -->
        </div>
    </div>
</template>
<script>

export default {
    name: 'TheFooterOther',
}
</script>